import React, { useEffect } from "react";
import {
  View,
  Text,
  ImageBackground,
  ScrollView,
  Image,
  TouchableOpacity,
  Dimensions,
} from "react-native";

import style from "./vr";
import Menu from "../menu";
import * as WebBrowser from "expo-web-browser";
import { FontAwesome5 } from "@expo/vector-icons";
import api from "../config/api_urls";
import AsyncStorage from "@react-native-community/async-storage";

function VistaVR(RouterData) {

  const [jocs360, setJocs360] = React.useState([]);

  
  RouterData.navigation.addListener("blur", () => {
    // Close iframe
  });

  RouterData.navigation.addListener("focus", () => {
    AsyncStorage.getItem("Jocs360").then((value) => {
      if (value != null) {
        setJocs360(JSON.parse(value));
      }
    });
  });

  useEffect(() => {
    AsyncStorage.getItem("Jocs360").then((value) => {
      if (value != null) {
        setJocs360(JSON.parse(value));
      }
    });
  }, []);

  const renderVistes = () => {
    let items = [];

    RouterData.route.params.projecte.vistes.map((vista, index) => {
      // disable if is in jocs360
      let disabled = false;
      jocs360.map((joc) => {
        if (joc.id == vista.id) {
          disabled = true;
        }
      });
      if (vista.Pregunta360 == true) {
        items.push(
          <View
            key={index}
            style={{
              flexGrow: 0.5,
              width: "90%",
              height: "100%",
              paddingTop: "3%",
              flex: 1,
              justifyContent: "center",
              alignSelf: "center",
            }}
          >
            <TouchableOpacity
              disabled={disabled} 
               onPress={() =>
                RouterData.navigation.navigate("Joc360", {
                  ...RouterData.route.params,
                  current360: vista,
                })
              }
              style={{ width: "100%" }}
            >
              <ImageBackground
                source={{ uri: api.api_url + vista.miniatura.url }}
                style={{ width: "100%", height: "100%", flex: 20 }}
              >
                <View
                  style={{
                    flex: 1,
                    alignContent: "center",
                    justifyContent: "center",
                    maxHeight: "100%",
                    width: "70%",
                    height: "100%",
                    paddingLeft: "1%",
                  }}
                >
                  <Text
                    style={{ width: "100%", maxWidth: "100%", fontSize: "9vh" }}
                  >
                    {" "}
                  </Text>
                </View>
              </ImageBackground>
              <View
                style={{
                  backgroundColor: disabled ? "#228B22" : "#f0efea",
                  flex: 9,
                  width: "100%",
                  height: "100%",
                  flexDirection: "row",
                  alignItems: "center",
                  borderBottomEndRadius: 5,
                  borderBottomStartRadius: 5,
                }}
              >
                <Text
                  style={{
                    fontSize: "2vh",
                    color: "black",
                    fontWeight: "bold",
                    paddingLeft: "5%",
                    color: "#334960",
                  }}
                >
                  {vista["Titol" + RouterData.route.params.idioma]}
                </Text>
                <View
                  style={{
                    flex: 1,
                    flexDirection: "row",
                    justifyContent: "flex-end",
                    alignItems: "center",
                    paddingRight: "5%",
                  }}
                >
                  <TouchableOpacity
                    onPress={() => _handlePressButtonAsync(vista.URL)}
                    style={{
                      marginRight: "5%",
                      padding: "1vh",
                      backgroundColor: "#e4ebf2",
                      borderRadius: 5,
                    }}
                  >
                    <FontAwesome5
                      name="vr-cardboard"
                      size={"2.5vh"}
                      color={"#8ba8c7"}
                    />
                  </TouchableOpacity>
                  <TouchableOpacity
                    style={{
                      marginRight: "5%",
                      padding: "1vh",
                      backgroundColor: "#e4ebf2",
                      borderRadius: 5,
                    }}
                    disabled={disabled} 
                    onPress={() =>
                      RouterData.navigation.navigate("Joc360", {
                        ...RouterData.route.params,
                        current360: vista,
                      })
                    }
                  >
                    <FontAwesome5
                      name="puzzle-piece"
                      size={"2.5vh"}
                      color={"#8ba8c7"}
                    />
                  </TouchableOpacity>
                </View>
              </View>
            </TouchableOpacity>
          </View>
        );
      }
    });
    return items;
  };


  const _handlePressButtonAsync = async (link) => {
    let result = await WebBrowser.openBrowserAsync(link);
  };


  return (
    <View style={{flex : 1}}>
    <ImageBackground source={RouterData.route.params.projecte['FonsPantalla6'] ? { uri: api.api_url + RouterData.route.params.projecte['FonsPantalla6'].url } : null} style={style.imageBackground}>

      <View
        style={{
          flex: 1,
          alignContent: "center",
          justifyContent: "center",
          maxHeight: "100%",
          width: "100%",
          height: "80%",
          // paddingBottom: "25%",
        }}
      >
        <ScrollView style={{ flexGrow: 1 , maxHeight:'70%' }} >{renderVistes()}</ScrollView>
        <View
          style={{ flex: 2, bottom: 0, left: 0, right: 0, position: "fixed" }}
        >
          <Menu projecte={RouterData.route.params}></Menu>
        </View>
      </View>
    </ImageBackground>
    </View>
  );
}

export default VistaVR;
